// extracted by mini-css-extract-plugin
module.exports = {"button":"QrGenerator_button__3Ygr8"};